import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import './styles.css';
import { App } from './App';
import { AdminApp } from './screens/admin/AdminApp';
import { ConfirmProvider } from './components/ConfirmDialog';
import { EmailVerifyLink } from './components/EmailVerify';
import { initPwa } from './pwa';

// PWA (KT-94): service worker və quraşdırma təklifi
initPwa();

// /admin — platforma admin paneli (ayrıca giriş və sessiya); qalan hər şey müştəri tətbiqi.
const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAdmin ? <AdminApp /> : <ConfirmProvider><EmailVerifyLink /><App /></ConfirmProvider>}
  </StrictMode>,
);
